import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Box,
  Text,
  VStack,
  Divider,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import axiosClient from "../../../../api/axiosClient";

import InformativeVerticalProgress from "./InformativeVerticalProgress";
import { buildTimeline } from "../../helpers/timeline";

export default function CategoryDetailDialog({
  isOpen,
  onClose,
  data,       // BASIC INFO (dari table / endpoint lain)
  endpoint,   // DETAIL ENDPOINT (comments, activity, dll)
}) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !endpoint) return;

    const fetchDetail = async () => {
      try {
        setLoading(true);
        const res = await axiosClient.get(`${endpoint}${data.id}`);
        setDetail(res.data.data ?? res.data);
      } catch (err) {
        console.error("Failed to load ticket detail", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [isOpen, endpoint]);

  if (!data) return null;

  console.log("detail ", detail);
  const timelineSteps = detail
    ? buildTimeline(detail)
    : [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Ticket Detail</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {loading ? (
            <Center py={10}>
              <Spinner size="lg" />
            </Center>
          ) : (
            <VStack align="stretch" spacing={4}>
              {/* BASIC INFO (DARI PROPS data) */}
              <Box>
                <Text fontWeight="bold">Subject</Text>
                <Text>{data.subject}</Text>
              </Box>

              <Box>
                <Text fontWeight="bold">Description</Text>
                <Text>{data.description}</Text>
              </Box>

              <Box>
                <Text fontWeight="bold">Category</Text>
                <Text>{data.category?.name ?? "-"}</Text>
              </Box>

              <Box>
                <Text fontWeight="bold">Assigned To</Text>
                <Text>{data.assigned_user?.name ?? "-"}</Text>
              </Box>

              <Divider />

              {/* PROGRESS & ACTIVITY (DARI ENDPOINT LAIN) */}
              <Box>
                <Text fontWeight="bold" mb={4}>
                  Progress & Activity
                </Text>

                <InformativeVerticalProgress steps={timelineSteps} />
              </Box>
            </VStack>
          )}
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
